@if (saving()) {
  <div class="locker"></div>
}
<div oui-dialog-title>
  <div class="flex-horizontal flex-center width-fill-available">
    <h6>Remplacer le document</h6>
  </div>
  <div class="content-right width-100-pc">
    <oui-button
      color="secondary"
      type="icon">
      <oui-icon mat-dialog-close>close</oui-icon>
    </oui-button>
  </div>
</div>
<oui-dialog-content [scroll]="true">
  <div class="flex-vertical gap-16">
    @if (fileControl.value?.length === 0) {
      <div class="file-uploader-container">
        <oui-file-uploader
          class="width-100-pc"
          type="single"
          [accept]="acceptedFileType"
          [control]="fileControl"
          [maxFileSize]="20"
          hint="Fichiers acceptés : PDF, JPEG, PNG, Word, Excel - Poids maximum par document : 20 Mo"></oui-file-uploader>
      </div>
    }
    @if (fileControl.value && fileControl.value.length > 0) {
      <div>
        <div class="document-card oui-elevation-04">
          <div class="flex-horizontal flex-center">
            @if (fileControl.value[0]; as file) {
              <oui-file-item
                type="condensed"
                class="width-fill-available"
                [file]="file"
                (delete)="deleteFile()">
              </oui-file-item>
            }
            <oui-date-picker
              [max]="maxSignatureDate()"
              [min]="minSignatureDate()"
              label="Date de signature"
              [control]="signatureDateControl"
              [pivotYear]="currentDatePivotYear"
              [errors]="dateErrors">
            </oui-date-picker>
          </div>
        </div>
      </div>
    }
  </div>
</oui-dialog-content>
<oui-dialog-actions>
  <oui-button
    type="text"
    oui-dialog-close>
    Annuler
  </oui-button>
  @if (saving()) {
    <oui-dialog-actions>
      <oui-loading
        size="xs"
        class="align-self-center">
      </oui-loading>
    </oui-dialog-actions>
  } @else {
    <oui-button
      type="contained"
      [disabled]="!signatureDateControl.valid || fileControl.value?.length === 0"
      (click)="replaceFile()">
      Remplacer
    </oui-button>
  }
</oui-dialog-actions>
